module.exports = __webpack_public_path__ + "assets/img/music-album-placeholder.677144cf.png";